import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle
} from '@/common/components/ui/card';
import { Button } from '@/common/components/ui/button';
import { Trash } from 'lucide-react';

const BookList = ({ bookings, onCancelBooking }) => (
  <>
    {bookings?.map(({ date, seat: { seatNumber, id: seatId, row, available }, office: { name: officeName, location } }) => (
      <Card key={`${seatId}-${date}`} className="w-full rounded-2xl border border-border/60 py-2 shadow-sm mt-2">
        <CardHeader>
          <CardTitle className="flex flex-row text-xl justify-between">
            <span>Desk {seatId} -  Row {row} </span>
            {onCancelBooking && (
              <Button variant="destructive" className="bg-transparent" onClick={() => onCancelBooking({ date, seatId: seatId || seatNumber, seatNumber, officeName })}
                title="Cancel this booking"
                aria-label="Cancel booking">
                <Trash />
              </Button>
            )}
          </CardTitle>
        </CardHeader>
        <CardContent className="grid gap-2 pb-5">
          <span>{location}</span>
          <span>{dayjs(date).toDate().toDateString()}</span>
          {available ? (
            <span className="inline-flex w-fit items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">Confirmed</span>
          ) : <span className="inline-flex w-fit items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800">Not available</span>}
        </CardContent>
      </Card>
    ))}
  </>
)

BookList.propTypes = {
  bookings: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
    seat: PropTypes.shape({
      seatNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      row: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      available: PropTypes.bool,
    }),
    office: PropTypes.shape({
      name: PropTypes.string,
      location: PropTypes.string,
    }),
  })),
  onCancelBooking: PropTypes.func,
}

export default BookList
